import script from "./CompanyInteraction.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyInteraction.vue?vue&type=script&setup=true&lang=js"

import "./CompanyInteraction.vue?vue&type=style&index=0&id=4057e1b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4057e1b0"]])

export default __exports__